import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.css']
})
export class PrivacypolicyComponent implements OnInit {

  constructor(private service:AppService,private router: Router) { }

  data:any='';
  loader:boolean=false;
  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completeprivacypolicy", "privacypolicy", "PrivacyPolicy");

    fbq('track', "CompletePrivacyPolicy" , {
      content_type: "privacypolicy",
      content_title: this.router.url,
    });
  }

    this.service.setTitle('Privacy Policies | Propira');
    this.service.setMetaTags({ property: "og:title", content: 'Privacy Policies | Propira' });
    this.service.setMetaTags({ name: "keywords", content: 'Privacy and Policy' });
    this.service.setMetaTags({ name: "description", content: 'Read privacy policy of Propira nd get details about user, voluntary, log file, information and data usage.' });
    this.service.setMetaTags({ property: "og:description", content: 'Read privacy policy of Propira nd get details about user, voluntary, log file, information and data usage.' });

    this.loader=true;
    this.service.get('/privacypolicyInfo').subscribe(
      data=>{
        if(data[0].error=='0'){
          this.data=data[0].description;
        }
        this.loader=false;
      },error=>{
        this.loader=false;
        console.log('in error');
      }
    )
  } 

}
